module.exports = __webpack_public_path__ + "static/media/error-icon.78cb38bb.png";